import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PublicHeader from '../../components/common/PublicHeader';
import PublicFooter from '../../components/common/PublicFooter';

const ForthcomingEventsPage = () => {
  // Sample data - in real app this would come from API
  const sampleEvents = [
    {
      id: 1,
      eventName: "36th Senior National Baseball Championship",
      eventDate: "15-20 March 2024",
      eventVenue: "CUTTACK, ODISHA",
      eventOrg: "AMATEUR BASEBALL FEDERATION OF INDIA"
    },
    {
      id: 2,
      eventName: "30th Sub-Junior National Baseball Championship",
      eventDate: "10-15 April 2024",
      eventVenue: "CHANDIGARH",
      eventOrg: "AMATEUR BASEBALL FEDERATION OF INDIA"
    },
    {
      id: 3,
      eventName: "15th Little League Baseball Championship",
      eventDate: "25-30 May 2024",
      eventVenue: "DEHRADUN, UTTARAKHAND",
      eventOrg: "AMATEUR BASEBALL FEDERATION OF INDIA"
    }
  ];

  useEffect(() => {
    document.title = 'Forthcoming Events | SportsTMS | THE OFFICIAL SPORTS MANAGEMENT SYSTEM';
  }, []);

  return (
    <div id="outer_m">
      <PublicHeader />

      {/* Main Content */}
      <div id="main">
        {/* Social Media Sticky Icons */}
        <div id="stickleft">
          <i className="fa fa-facebook-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-youtube-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-twitter-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
          <i className="fa fa-linkedin-square" style={{fontSize:'32px', marginLeft:'2px', cursor:'pointer', color:'#022a5e'}}></i>
        </div>

        <Link to="/events">
          <div id="stick_right"></div>
        </Link>

        <div id="basic">
          <h3 className="heading3">Forthcoming Events</h3>
          <p className="basic_p">Stay updated with upcoming baseball championships and tournaments.</p>
          
          <div className="row">
              {sampleEvents.length > 0 ? (
                sampleEvents.map((event) => (
                  <div key={event.id} className="col-xs-12 col-md-5" style={{margin: '0 auto', float: 'none'}}>
                    <div className="panel panel-info" style={{position: 'relative', textAlign: 'center', marginBottom: '30px'}}>
                      {/* Corner Flash */}
                      <div style={{
                        position: 'absolute',
                        top: '-9px',
                        right: '4px',
                        zIndex: 1,
                        overflow: 'hidden',
                        width: '100px',
                        height: '100px',
                        borderRadius: '3px 5px 3px 0'
                      }}>
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          right: 0,
                          width: '145px',
                          height: '145px',
                          transform: 'rotate(45deg)',
                          transformOrigin: '100% 100%',
                          backgroundImage: 'linear-gradient(90deg, transparent 50%, rgba(255,255,255,.1) 50%), linear-gradient(0deg, transparent 0%, rgba(1,1,1,.2) 50%)',
                          backgroundSize: '4px,auto, auto,auto',
                          backgroundColor: '#aa0101',
                          boxShadow: '0 3px 3px 0 rgba(1,1,1,.5), 0 1px 0 0 rgba(1,1,1,.5), inset 0 -1px 8px 0 rgba(255,255,255,.3), inset 0 -1px 0 0 rgba(255,255,255,.2)'
                        }}>
                          <span style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            display: 'block',
                            width: '100%',
                            paddingBottom: '5px',
                            color: '#fff',
                            textShadow: '0 1px 1px rgba(1,1,1,.8)',
                            fontSize: '0.95em',
                            fontWeight: 'bold',
                            textAlign: 'center'
                          }}>
                            NEW<br />EVENT
                          </span>
                        </div>
                      </div>

                      <div className="panel-heading">
                        <img src="/logo.png" width="60" height="60" alt="SportsTMS Logo" />
                      </div>
                      
                      <div className="panel-body" style={{padding: '0px', textAlign: 'center'}}>
                        <div style={{
                          backgroundColor: 'rgba(220,220,220,.17)',
                          boxShadow: '0 1px 0 #dcdcdc, inset 0 1px 0 #fff',
                          padding: '20px',
                          margin: 0
                        }}>
                          <h2 style={{lineHeight: '1em', padding: 0, margin: 0}}>
                            {event.eventName.toUpperCase()}
                          </h2>
                        </div>
                        
                        <table className="table">
                          <tbody>
                            <tr>
                              <td>
                                <a className="btn btn-danger btn-lg active">
                                  <b>{event.eventDate}</b>
                                </a>
                              </td>
                            </tr>
                            <tr className="active">
                              <td>
                                <h4>Venue</h4>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h4><b>{event.eventVenue.toUpperCase()}</b></h4>
                              </td>
                            </tr>
                            <tr className="active">
                              <td>
                                <h4>Hosted By</h4>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <h4><b>{event.eventOrg}</b></h4>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      
                      <div className="panel-footer">
                        <a className="btn btn-primary active">SportsTMS</a>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="panel panel-default text-center">
                  <div className="panel-body">
                    <p className="lead">Currently there are no upcoming events.</p>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>

      <PublicFooter />
    </div>
  );
};

export default ForthcomingEventsPage;